import React, { useCallback, useEffect, useRef, useState } from "react";
import { Form, Row, Col, Space, Button, Spin, Modal } from "antd";
import { InputFields } from "components/common";
import { dataFields } from "./config";
import moment from "moment";
import Notification from "components/common/notification/notification";

import {
  EditorState,
  ContentState,
  convertToRaw,
  convertFromHTML,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import { Editor } from "react-draft-wysiwyg";
import Upload, { UploadFile, UploadProps } from "antd/es/upload";

import residentialNurseService from "api/residentialNurse";
import { medicalExaminationService } from "api";
import { getImageSrc } from "pages/Receive/ExtendCard/config";
import { fontOptions } from "pages/Electrocardiography/tabs/DetailDiagnose/ElectrocardiographyInfo/TextEditor";

const ModalContent = (props) => {
  const { data, closeModal, type, getListDiagnose } = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [editorState, setEditorState] = useState(null);

  const onEditorStateChange = useCallback((editorState) => {
    setEditorState(editorState);
  }, []);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");

  const [fileList, setFileList] = useState([]);

  const handleCancel = () => setPreviewOpen(false);

  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getImageSrc(previewImage);
    }

    const segments = file.url?.split("-");

    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
    setPreviewTitle(file.name || segments[segments.length - 1]);
  };

  const handleChange: UploadProps["onChange"] = async ({
    fileList: newFileList,
  }) => {
    const image = newFileList[0].originFileObj;
    const formData = new FormData();
    formData.append("imageFile", image);

    setFileList(newFileList);
    try {
      const response = await medicalExaminationService.uploadImage(formData);

      if (response.status == 200) {
        setPreviewImage(response.data.imageId);
      }
    } catch (err) {
      Notification("error", "Lỗi khi tải lên ảnh");
    }
  };

  useEffect(() => {
    if (type == "Thêm") {
      form.resetFields();
      setFileList([]);
      setEditorState(null);
    } else {
      if (data?.anh) {
        setFileList([{ url: getImageSrc(data.anh) }]);
      } else setFileList([]);

      form.setFieldsValue(data);
    }
  }, [data]);

  const addDilate = async () => {
    setLoading(true);
    try {
      const params = form.getFieldsValue();

      const formatValues = {
        ...params,
        moTa: editorState
          ? draftToHtml(convertToRaw(editorState.getCurrentContent()))
          : "",
        anh: previewImage ?? null,
      };

      await residentialNurseService.postCatalogById(formatValues);

      await getListDiagnose();

      setLoading(false);

      form.resetFields();
      setFileList([]);
      setEditorState(null);

      closeModal();

      Notification("success", "Thêm mới mẫu điện tim thành công");
    } catch (error) {
      setLoading(false);
      
      Notification("error", "Thêm mới mẫu điện không thành công");
    }
  };
  const editDilate = async () => {
    setLoading(true);
    try {
      const params = form.getFieldsValue();
      const formatValues = {
        ...params,
        moTa: draftToHtml(convertToRaw(editorState.getCurrentContent())),
        anh: previewImage ?? null,
      };

      const res = await residentialNurseService.putCatalogById(
        data.id,
        formatValues
      );

      await getListDiagnose();
      setLoading(false);
      Notification("success", "Cập nhật mẫu điện tim thành công");
      closeModal();
    } catch (error) {
      setLoading(false);
      Notification("error", "Cập nhật mẫu điện không thành công");
    }
  };

  useEffect(() => {
    if (data?.moTa) {
      const blockFromHTMl = convertFromHTML(data?.moTa);
      const state = ContentState.createFromBlockArray(
        blockFromHTMl.contentBlocks,
        blockFromHTMl.entityMap
      );
      setEditorState(EditorState.createWithContent(state));
    } else setEditorState(null);

    form.setFieldsValue({
      ...data,
    });
  }, [data]);

  const onFinish = () => {
    if (type == "Thêm") {
      addDilate();
    } else {
      editDilate();
    }
  };

  return (
    <div>
      <Spin spinning={loading}>
        <Form form={form} onFinish={onFinish}>
          <Space direction="vertical" style={{ width: "100%" }}>
            <Row gutter={[16, 8]}>
              <InputFields data={dataFields}></InputFields>
            </Row>
            <Row style={{ width: "100%" }}>
              <Col xl={24} className="editor">
                <Form.Item
                  label="Mô tả"
                  name={"moTa"}
                  labelCol={{ xl: 3 }}
                  wrapperCol={{ xl: 21 }}
                  labelAlign="left"
                >
                  <Editor
                    editorState={editorState}
                    wrapperClassName="demo-wrapper"
                    editorClassName="demo-editor"
                    onEditorStateChange={onEditorStateChange}
                    toolbar={fontOptions}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ width: "100%" }}>
              <Col xl={24}>
                <Form.Item
                  label="Lược đồ PPPT"
                  labelAlign="left"
                  labelCol={{ xl: 3 }}
                  wrapperCol={{ xl: 21 }}
                  name="anh"
                >
                  <Upload
                    listType="picture-card"
                    fileList={fileList}
                    onPreview={handlePreview}
                    onChange={handleChange}
                    maxCount={1}
                  >
                    Tải lên
                  </Upload>
                  <Modal
                    open={previewOpen}
                    title={previewTitle}
                    footer={null}
                    onCancel={handleCancel}
                  >
                    <img
                      alt="example"
                      style={{ width: "100%" }}
                      src={previewImage}
                    />
                  </Modal>
                </Form.Item>
              </Col>
            </Row>
            <Row justify="end">
              <Col>
                <Space>
                  <Button onClick={closeModal}>Hủy</Button>
                  <Button htmlType="submit" type="primary">
                    Xác nhận
                  </Button>
                </Space>
              </Col>
            </Row>
          </Space>
        </Form>
      </Spin>
    </div>
  );
};
export default ModalContent;
